import { OVERLAY_DEFAULT_CONFIG, OverlayDefaultConfig } from '@angular/cdk/overlay';
import { Provider } from '@angular/core';

// Angular 22's CDK renders every overlay inside a native popover (usePopover defaults to true),
// which promotes it to the browser top layer. The top layer paints above all normal-flow content
// regardless of z-index, so in-page popups that sit above overlays by design - the explainer
// dialog at z-index 1002, mounted in LayoutComponent outside the overlay container - can never
// win against a MatDialog. Opting out restores the pre-22 z-index stacking model. ADO 18132.
const overlayDefaultConfig: OverlayDefaultConfig = { usePopover: false };

export const OVERLAY_POPOVER_OPT_OUT: Provider = {
  provide: OVERLAY_DEFAULT_CONFIG,
  useValue: overlayDefaultConfig,
};
